import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|Exams|Violations|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Exam,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateHistoryExamViolations';
export type SPCandidateHistoryExamViolationsLocNames =
	| `${LocNameStart}ContentCreatedDateMissing`
	| `${LocNameStart}TitleSection`
	| `${LocNameStart}ButtonAddViolation`
	| `${LocNameStart}LabelCreatedDate`
	| `${LocNameStart}LabelViolationType`
	| `${LocNameStart}LabelSubtype`
	| `${LocNameStart}LabelDetails`
	| `${LocNameStart}TitleTab`;

export const spCandidateHistoryExamViolationsLocs: LocDefs<SPCandidateHistoryExamViolationsLocNames> =
	{
		SPCandidateHistoryExamViolationsContentCreatedDateMissing: {
			defaultValue: '',
			description: 'Created date missing message',
			displayPath: `${pathStart}Created date missing`,
			displayType: 'Content',
			legacyName: 'Exam/CandidateExamViolations.Content.CreatedDateMissing',
			...sharedProperties,
		},
		SPCandidateHistoryExamViolationsTitleSection: {
			defaultValue: 'Exam Violations',
			description: 'Section title',
			displayPath: `${pathStart}Section title`,
			displayType: 'Label',
			legacyName: 'Exam/CandidateExamViolations.Title.SectionDetails',
			...sharedProperties,
		},
		SPCandidateHistoryExamViolationsButtonAddViolation: {
			defaultValue: 'Add violation',
			description: 'Add violation button text for accessibility.',
			displayPath: `${pathStart}Add violation`,
			displayType: 'Button',
			legacyName: 'Exam/CandidateExamViolations.Button.AddViolationAria',
			...sharedProperties,
		},
		SPCandidateHistoryExamViolationsLabelCreatedDate: {
			defaultValue: 'Date',
			description: 'Column heading for: Date.',
			displayPath: `${pathStart}Date`,
			displayType: 'Label',
			legacyName: 'Exam/CandidateExamViolations.ColumnHeading.Date',
			...sharedProperties,
		},
		SPCandidateHistoryExamViolationsLabelViolationType: {
			defaultValue: 'Violation',
			description: 'Column heading for: Violation.',
			displayPath: `${pathStart}Violation`,
			displayType: 'Label',
			legacyName: 'Exam/CandidateExamViolations.ColumnHeading.Violation',
			...sharedProperties,
		},
		SPCandidateHistoryExamViolationsLabelSubtype: {
			defaultValue: 'Subtype',
			description: 'Column heading for: Subtype.',
			displayPath: `${pathStart}Subtype`,
			displayType: 'Label',
			legacyName: 'Exam/CandidateExamViolations.ColumnHeading.Subtype',
			...sharedProperties,
		},
		SPCandidateHistoryExamViolationsLabelDetails: {
			defaultValue: 'Details',
			description: 'Column heading for: Details.',
			displayPath: `${pathStart}Details`,
			displayType: 'Label',
			legacyName: 'Exam/CandidateExamViolations.ColumnHeading.Details',
			...sharedProperties,
		},
		SPCandidateHistoryExamViolationsTitleTab: {
			defaultValue: 'Violations',
			description: 'Tab title',
			displayPath: `${pathStart}Tab title`,
			displayType: 'Title',
			legacyName: 'Exam/CandidateExamViolations.Title.Tab',
			...sharedProperties,
		},
	};

export type SPCandidateHistoryExamViolationsLocType =
	LocMap<SPCandidateHistoryExamViolationsLocNames>;
